import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import FormError from "../FormError/FormError";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0;
`;

const StyledLabel = styled.label`
  width: 80%;
  display: block;
  font-weight: normal;
  font-size: 19px;
  margin-left: 10px;
`;

const StyledCheckbox = styled.input`
  width: 20%;
  display: block;
  width: 35px;
  height: 35px;
  margin-right: 5px;
`;

const FormCheckbox = ({
  name,
  label,
  register,
  required,
  error,
  errorMessage = "This is required",
  value,
  onClick = () => {},
  dataTestid,
}) => {
  return (
    <>
      <StyledDiv>
        <StyledCheckbox
          id={name}
          name={name}
          type="checkbox"
          ref={register({ required })}
          aria-invalid={error ? "true" : "false"}
          value={value}
          onClick={onClick}
          data-testid={dataTestid}
        />
        <StyledLabel htmlFor={name}>{label}</StyledLabel>
      </StyledDiv>
      {error?.type === "required" && <FormError error={errorMessage} />}
    </>
  );
};

FormCheckbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  register: PropTypes.func.isRequired,
  required: PropTypes.bool,
  error: PropTypes.shape({
    type: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func,
  dataTestid: PropTypes.string,
};

export default FormCheckbox;
